import React from "react";
import { Container, Stack } from "@mui/material";
import DeleteShippingCostDialog from "./shippingCostManagement/DeleteShippingCostDialog";
import ShippingCostContent from "./shippingCostManagement/ShippingCostContent";
import ShippingCostFilters from "./shippingCostManagement/ShippingCostFilters";
import ShippingCostFormDialog from "./shippingCostManagement/ShippingCostFormDialog";
import ShippingCostManagementHeader from "./shippingCostManagement/ShippingCostManagementHeader";
import ShippingCostToast from "./shippingCostManagement/ShippingCostToast";
import { useShippingCostManagement } from "./shippingCostManagement/useShippingCostManagement";

export default function ShippingCostManagement() {
    const {
        openDialog,
        loading,
        error,
        currentShippingCost,
        deleteAsk,
        fieldErrors,
        toast,
        query,
        sortBy,
        gross,
        filteredSorted,
        groupedShippingCosts,
        setQuery,
        setSortBy,
        setCurrentShippingCost,
        setDeleteAsk,
        handleDialogOpen,
        handleDialogClose,
        handleEdit,
        handleDeleteAsk,
        handleDeleteConfirm,
        handleFieldChange,
        handleSave,
        handleRefresh,
        closeToast,
    } = useShippingCostManagement();

    return (
        <>
            <ShippingCostManagementHeader onRefresh={handleRefresh} onCreate={handleDialogOpen} />
            <Container maxWidth="lg" sx={{ mt: 4, pb: 6 }}>
                <Stack spacing={3}>
                    <ShippingCostFilters
                        query={query}
                        sortBy={sortBy}
                        onQueryChange={setQuery}
                        onSortChange={setSortBy}
                    />
                    <ShippingCostContent
                        loading={loading}
                        error={error}
                        hasResults={filteredSorted.length > 0}
                        groups={groupedShippingCosts}
                        onCreate={handleDialogOpen}
                        onEdit={handleEdit}
                        onDelete={handleDeleteAsk}
                    />
                </Stack>
            </Container>

            <ShippingCostFormDialog
                open={openDialog}
                shippingCost={currentShippingCost}
                fieldErrors={fieldErrors}
                gross={gross}
                onClose={handleDialogClose}
                onFieldChange={handleFieldChange}
                onToggleActive={(event) =>
                    setCurrentShippingCost((prev) => ({ ...prev, active: event.target.checked }))
                }
                onSave={handleSave}
            />

            <DeleteShippingCostDialog
                deleteAsk={deleteAsk}
                onCancel={() => setDeleteAsk(null)}
                onConfirm={handleDeleteConfirm}
            />

            <ShippingCostToast toast={toast} onClose={closeToast} />
        </>
    );
}
